import React from 'react';
type ColorCheckboxProps = {
  label: string;
  checked: boolean;
  color?: string;
  onChange: (checked: boolean) => void;
};
export function ColorCheckbox({
  label,
  checked,
  color = '#0a63c9',
  onChange
}: ColorCheckboxProps) {
  return <button type="button" role="checkbox" aria-checked={checked} aria-label={label} onClick={() => onChange(!checked)} className="flex h-[12px] w-[12px] shrink-0 items-center justify-center rounded-[2.5px] border transition-colors duration-150" style={{
    backgroundColor: checked ? color : '#fff',
    borderColor: checked ? color : '#c9ccd0'
  }} data-id="element-812" data-mp="36kp44rgw3k3o">
      
      {checked && <svg viewBox="0 0 12 12" className="h-[9px] w-[9px]" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-813" data-mp="3pbgadk5kyudu">
          <path d="M2.5 6.3 L5 8.6 L9.5 3.6" data-id="element-814" data-mp="2dtxao1r7l9k1" />
        </svg>}
    </button>;
}